import { v4 as uuidv4 } from 'uuid'

const TRACE_ID_KEY = 'Evreka-Trace-Id'

export const setTraceId = (traceId?: string) => {
  const newTraceId = traceId || uuidv4()
  localStorage.setItem(TRACE_ID_KEY, newTraceId)
  return newTraceId
}

export const getTraceId = () => {
  let traceId = localStorage.getItem(TRACE_ID_KEY)
  if (!traceId) {
    traceId = setTraceId()
  }
  return traceId
}

export const resetTraceId = () => {
  setTraceId()
}
